import type { UserAddress } from '../../store/structureDefinitions/userState';

import { SessionStorageFacade } from '../../../../facades/storage/sessionStorageFacade';

const SESSION_KEY: string = 'temporaryAddresses';
const getSessionKey = (userId: string, type: 'delivery' | 'invoice') => {
    return `${SESSION_KEY}:${userId}:${type}`;
};

const temporaryAddressSession = {
    get: (userId: string, type: 'delivery' | 'invoice') => {
        return SessionStorageFacade.instance.getObject<UserAddress>(getSessionKey(userId, type));
    },
    add: (userId: string, type: 'delivery' | 'invoice', address: UserAddress) => {
        SessionStorageFacade.instance.addObject(getSessionKey(userId, type), address);
    },
    remove: (userId: string, type: 'delivery' | 'invoice') => {
        SessionStorageFacade.instance.remove(getSessionKey(userId, type));
    },
};

export default temporaryAddressSession;
